"use client";
import styles from './index.module.scss';
import IconButton from "@/app/_components/Shared/IconButton";
import {useRouter} from "nextjs-toploader/app";

export default function BusinessSetupPage() {
    const router = useRouter();

    const onClick = () => {
        router.push('/business-setup-request');
    }

    return (
        <div className={"container-wrapper "+ styles.wrapper}>
            <div className={styles.container}>
                <div className={"container-wrapper"}>
                    <div className={styles.content}>
                        <h1>Set Up Your Business in the UAE with Ease</h1>
                        <h2>How Much Does Business Setup in the UAE Cost?</h2>
                        <p>
                            It depends. What type of business are you looking to set up? Mainland, Free Zone, or
                            Offshore?
                            How
                            many visas or shareholders do you need? With years of experience in helping entrepreneurs
                            establish
                            their businesses in the UAE, we’ve created the Ninjaz Business Setup Cost Calculator to give
                            you
                            a
                            personalized estimate. Start now to get a clear picture of the costs involved in setting up
                            your
                            business in the UAE.
                        </p>
                        <div className={styles.buttons}>
                            <IconButton onClick={onClick}>
                                Start Now
                            </IconButton>
                            <IconButton onClick={onClick} color="secondary">
                                Get Your Free Quote
                            </IconButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
